module.exports = __webpack_public_path__ + "img/cl_login_pic.df6e8725.png";